import {TrancheReductionDTO} from "./tranche-reduction-dto";
import {ParametreCalculConditionnementMl} from "../../models/gestion-conditionnements/parametre-calcul-conditionnement-ml";

export class ParametreCalculConditionnementDTO {
  siteId: number;
  minimumBarquetteNumberRequired: Number;
  trancheReductionList: TrancheReductionDTO[];

  constructor(model: ParametreCalculConditionnementMl) {
    this.siteId = model.siteId;
    this.minimumBarquetteNumberRequired = model.minimumBarquetteRequired;
    this.trancheReductionList = model.trancheReductionList.map(tranche => new TrancheReductionDTO(tranche));
  }
}
